export const FILTER_OPERATORS = {
	in: { 
		code: "In" as const,
		display: "In" as const
	},
	equals: { 
		code: "Equals" as const,
		display: "=" as const
	},
	greaterThan: { 
		code: "GreaterThan" as const,
		display: ">" as const
	},
	greaterThanOrEqualTo: { 
		code: "GreaterThanOrEqualTo" as const ,
		display: ">=" as const
	},
	lessThan: { 
		code: "LessThan" as const,
		display: "<" as const
	},
	lessThanOrEqualTo: { 
		code: "LessThanOrEqualTo" as const ,
		display: "<=" as const
	}
};

export const SORT_DIRECTIONS = {
	ascending: {
		code: "Ascending",
		display: "Ascending"
	},
	descending: {
		code: "Descending",
		display: "Descending"
	}
};

export const CURSOR_DIRECTIONS = {
	forward: {
		code: "Forward",
		display: "Forward"
	},
	backward: {
		code: "Backward",
		display: "Backward"
	}
};

export const EXPORT_STATUSES = {
	committed: "COMMITTED",
	suppressed: "SUPPRESSED",
	errored: "ERRORED",
	pending: "PENDING"
};